import { useTranslation } from 'react-i18next';
import { cartLineTotal, formatCurrency } from '~/utils';

type CartItemLineTotalProps = {
  displayPricePerUnit: number | null;
  rawPricePerPiece: number | null;
  piecesCount: number;
  displayQuantity: number;
  currency?: string;
};

/**
 * Prices the line off pieces whenever a per-piece figure is known, so the shown
 * arithmetic holds (price × pieces = total) even when the display unit is not PCS.
 */
export function CartItemLineTotal({
  displayPricePerUnit,
  rawPricePerPiece,
  piecesCount,
  displayQuantity,
  currency,
}: Readonly<CartItemLineTotalProps>) {
  const { t } = useTranslation('cart');

  if (displayPricePerUnit == null) {
    return (
      <div className="flex items-center justify-end gap-2">
        <p className="text-lg text-neut-prim font-semibold">
          {t('cart.price_not_available')}
        </p>
      </div>
    );
  }

  const total = cartLineTotal({
    displayPricePerUnit,
    rawPricePerPiece,
    piecesCount,
    displayQuantity,
  });

  return (
    <div className="flex items-center justify-end gap-2">
      <p className="text-lg text-neut-prim font-semibold">
        {formatCurrency(total, currency)}
      </p>
    </div>
  );
}
